// extracted by mini-css-extract-plugin
module.exports = {"discontinued_hint":"DiscontinuedHint_discontinued_hint__47cdc","discontinued_cta":"DiscontinuedHint_discontinued_cta__c96f2"};